import React from "react";
interface Props {
  link: string;
  title: string;
  displayResourceLink: boolean;
}
const ResourceLink = ({
  link,
  title,
  displayResourceLink
}: Props) => <li className="item" style={{
  display: displayResourceLink ? "block" : "none"
}} data-no-jquery data-sentry-component="ResourceLink" data-sentry-source-file="ResourceLink.tsx">
    <i className="icon-book-open" />
    <a className="description" href={link} title={title} target="_blank">
      {title}
    </a>
  </li>;
export default ResourceLink;